import React, { useEffect, useState } from 'react'
import { Select, Space, Typography } from 'antd'
import { Label } from 'reactstrap'
import { useSelector, useDispatch } from 'react-redux'
import { fetchActiveTrips } from '@/store/actions'
import { TripPicture } from '../TripPicture'
const { Option } = Select

export const TripList = ({ onChange, selected, placeholder, showLabel }) => {
  const dispatch = useDispatch()
  const { loading, activeTrips } = useSelector((state) => state.dashboard)
  const [trips, setTrips] = useState(activeTrips || [])
  useEffect(() => {
    dispatch(fetchActiveTrips({ includeDraft: true }))
  }, [])
  const onSearch = (inputValue) => {
    setTrips(
      activeTrips.filter((trip) => {
        return trip.title.toLowerCase().includes(inputValue.toLowerCase())
      })
    )
  }
  useEffect(() => {
    setTrips(activeTrips)
  }, [activeTrips])
  return (
    <>
      {showLabel ? <Label>Hosts</Label> : ''}
      <Select
        showSearch
        mode="multiple"
        placeholder={placeholder || 'Select trip'}
        value={selected}
        onChange={onChange}
        loading={loading}
        filterOption={false}
        onSearch={onSearch}
      >
        {trips &&
          trips?.map((val) => (
            <Option key={val._id} value={val._id}>
              <Space align="start">
                {/* <TripPicture
                  trip={val}
                  height="75px"
                  width="75px"
                  preview={false}
                  style={{ borderRadius: '5px' }}
                /> */}
                <Typography.Text>{val.title}</Typography.Text>
              </Space>
            </Option>
          ))}
      </Select>
    </>
  )
}
